export default {
  title: "Service Info",
  category: "Category",
  type_of_service: "Type of service",
  subtype_of_service: "Subtype of service",
  not_especified: "--",
};
